import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { INVENTORY_API_BASE_URL_2 } from '../../services/TapApiUrls';
import api from '../../services/api';

const QRCodeLabelPrinter = (params) => {

    const accessToken       =   useSelector(state => state.auth.access_token);

    const [printData, setPrintData] =   useState({})
    const [loading, setLoading]     =   useState(false)

    useEffect(() => {
        fetchQRCode()
    }, [])

    const fetchQRCode   =   async ()    =>  {
        setLoading(true);
        try {
            const response      =   await api.server2Api.get(INVENTORY_API_BASE_URL_2 + '/item_qr_code/8xLIJg==',{ headers: { 'Authorization': 'Bearer ' + accessToken } });
            setPrintData(response.data);
        } catch (error) {
            alert('Failed to fetch QR code');
        } finally {
            setLoading(false);
        }
    };

    const decodeBase64SVG = (base64String) => {
        if (!base64String) return '';

        let base64Data = base64String.includes('base64,')
            ? base64String.split('base64,')[1]
            : base64String;

        try {
            return atob(base64Data);
        } catch (error) {
            console.error('Error decoding:', error);
            return '';
        }
    };


    return (
        <div
            style={{
                width: '100%',
                minHeight: '200px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: '#f5f5f5',
            }}
        >

            <div
                style={{
                    width: '3.8in',
                    height: '1.8in',
                    background: '#fff',
                    border: '2px solid #000',
                    padding: '10px',
                    boxSizing: 'border-box',
                }}
            >
                <div>
                    <p
                        style={{
                            margin: 0,
                            fontSize: '14px',
                            fontWeight: '700',
                            textAlign: 'center',
                            paddingBottom: '6px',
                        }}
                    >
                        {printData?.company_data?.name.length > 50 ? printData?.company_data?.name.substring(0, 47) + '...' : printData?.company_data?.name}
                    </p>
                </div>


                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <div style={{ fontSize: '13px', width: '70%', }}>
                        <p style={{ margin: 0 }}>
                            NAME <strong>{printData?.name}</strong>
                        </p>

                        <p style={{ margin: 0 }}>
                            CODE <strong>{printData?.code}</strong>
                        </p>

                        <p style={{ margin: 0 }}>
                            MANUFACTURER <strong>{printData?.manufacturer?.length > 20 ? printData?.manufacturer.substring(0, 17) + '...' : printData?.manufacturer}</strong>
                        </p>

                        <p style={{ margin: 0 }}>
                            BATCH NO <strong>{printData?.batch_number}</strong>
                        </p>

                        <p style={{ margin: 0 }}>
                            EXPIRY DATE <strong>{printData?.expiry_date}</strong>
                        </p>

                        <p style={{ margin: 0 }}>
                            QTY <strong>{printData?.qty}</strong>
                        </p>
                    </div>
                    <div
                        style={{
                            width: '29%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <div

                            style={{
                                width: '91px',
                                height: '91px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                            dangerouslySetInnerHTML={{ __html: decodeBase64SVG(printData?.qr_code) }} />
                    </div>
                </div>

                <p
                    style={{
                        fontSize: '13px',
                        fontWeight: '600',
                        marginBottom : "0px",
                        marginTop: "0px",
                        textAlign: "right"
                    }}
                >
                    PRINT DATE : 25.05.2026
                </p>
            </div>

        </div>
    );
};

export default QRCodeLabelPrinter;